import { render } from "./downloadedReports.vue?vue&type=template&id=457ffcc0&scoped=true"
import script from "./downloadedReports.vue?vue&type=script&lang=js"
export * from "./downloadedReports.vue?vue&type=script&lang=js"

import "./downloadedReports.vue?vue&type=style&index=0&id=457ffcc0&scoped=true&lang=css"

import exportComponent from "/private/var/www/html/digicheck-laravel-vue-app/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457ffcc0"]])

export default __exports__